export const getAccessToken = state => state.pursue.accessToken
export const getGoogleAuthLink = state => state.pursue.googleAuthLink
export const getGoogleContacts = state => state.pursue.contacts
export const getFetchPursueStatus = state => state.pursue.getPursueStatus
export const getGoogleContactsStatus = state => state.pursue.googleContactsStatus
export const getPursueInstance = state => state.pursue.pursueInstance
export const getPursueInstanceStatus = state => state.pursue.pursueInstanceStatus
export const getPursueStatus = state => state.pursue.pursueStatus
export const getTaskPursueInstance = state => state.pursue.taskPursueInstance